import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

const AdminLayout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth > 768);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const closeSidebarOnMobile = () => {
        if (window.innerWidth <= 768) setSidebarOpen(false);
    };

    return (
        <div className="admin-layout-root">
            <Sidebar isOpen={sidebarOpen} onNavigate={closeSidebarOnMobile} />
            <div className={`admin-content-wrapper ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
                <Header toggleSidebar={toggleSidebar} />
                <main className="admin-main-content">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;